<rask-list
  [data]="searchResult"
  class="footer-padding"
  [virtualScroll]="true"
  virtualScrollType="window"
  [virtualScrollItemHeight]="36"
  [fixedHeader]="true"
  [useClientFilter]="true"
  [rowSelectable]="true"
  clientFilterResultText="Externa kontrakt"
  (checkedChanged)="onCheckedChange()">
  <rask-list-column-checkbox></rask-list-column-checkbox>
  <rask-list-column header="Kontraktsnummer" field="kontrakt" [sortable]="true" width="90px">
    <ng-template let-row="row">
      @if (row.kontrakt) {
        <a [routerLink]="['/virkeskop/avtal', row.kontrakt.avtalId]" [queryParams]="{ kontraktId: row.kontrakt.id }">
          {{ row.kontrakt.kontraktnummer }}
        </a>
      }
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Beteckning" field="externBeteckning" [sortable]="true" width="80px"></rask-list-column>
  <rask-list-column header="Leverantör" field="externOrganisation" [sortable]="true" width="80px"></rask-list-column>
  <rask-list-column header="Status" field="status" [sortable]="true" width="40px">
    <ng-template let-row="row">
      <rask-icon [text]="row.felmeddelande" [icon]="getIcon(row.status)" (click)="openLog(row)"></rask-icon>
    </ng-template>
  </rask-list-column>
  <rask-list-column header="Namn" field="externNamn" [sortable]="true" width="80px"></rask-list-column>
  <rask-list-column header="Datum mottagen" field="forstaDokumentdatum" [sortable]="true" width="80px">
    <ng-template let-row="row"><span>{{ row.forstaDokumentdatum | date:'yyyy-MM-dd' }}</span></ng-template>
  </rask-list-column>
  <rask-list-column header="Datum uppdaterad" field="uppdateradDokumentdatum" [sortable]="true" width="80px">
    <ng-template let-row="row"><span>{{ row.uppdateradDokumentdatum | date:'yyyy-MM-dd' }}</span></ng-template>
  </rask-list-column>
  <rask-list-column header="Planerare" field="planerare" [sortable]="true" width="80px"></rask-list-column>
  <rask-list-column header="Telefon" field="planerareTelefon" [sortable]="true" width="80px"></rask-list-column>
  <rask-list-column header="Dokument" field="selected" [sortable]="false" width="40px">
    <ng-template let-row="row">
      @if (row.dokument?.length > 0) {
        <span [ngbPopover]="getDokumentInfo(row)" triggers="mouseenter:mouseleave"
        container="body">({{ row.dokument.length }})</span>
      }
    </ng-template>
  </rask-list-column>
</rask-list>

<ng-template #template>
  APA BEPA
  <ng-content></ng-content>
</ng-template>

<div #templateResult style="display: none;">
  <ng-container *ngTemplateOutlet="template"></ng-container>
</div>